import React, { useState } from "react";

import { Grid, Tab, Tabs } from "@mui/material";

import TabPanel from "../components/shared/tab-panel";
import mainStyles from "../styles";
import PeriscopeHistory from "./periscope-history";
import SudoHistory from "./sudo-history";

const Reports: React.FC = () => {
  const classes = mainStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number
  ) => {
    setTabValue(newValue);
  };

  const tabs = [
    {
      label: "Sudo History",
      component: <SudoHistory />,
      enabled: true,
    },
    {
      label: "Periscope History",
      component: <PeriscopeHistory />,
      enabled: true,
    },
  ];

  return (
    <Grid container sx={classes.basicSpacing} spacing={1}>
      <Grid item xs={12}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          {tabs.map((tab) => {
            if (tab.enabled) {
              return (
                <Tab
                  label={tab.label}
                  key={tab.label}
                  data-testid="tab-option"
                />
              );
            }
            return undefined;
          })}
        </Tabs>
        {tabs.map((tab, index) => {
          return (
            <div key={tab.label}>
              <TabPanel value={tabValue} index={index}>
                {tab.component}
              </TabPanel>
            </div>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Reports;
